/** Runtime configuration for store API vs mock data */

export interface StoreApiConfig {
  baseUrl: string;
  storeId: string;
  storefrontId?: string;
  authToken?: string;
  /** Optional fetch override (e.g. Cloudflare service binding). */
  fetch?: typeof fetch;
}

declare global {
  interface Window {
    LANDI_STORE_API_BASE?: string;
    LANDI_STORE_API_TOKEN?: string;
    LANDI_STORE_ID?: string;
    LANDI_STOREFRONT_ID?: string;
  }
}

const DEFAULT_STORE_ID = 'store-1';

export function getStoreApiConfig(): StoreApiConfig | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const baseUrl = (window.LANDI_STORE_API_BASE ?? '').replace(/\/$/, '');

  if (!baseUrl) {
    return null;
  }

  return {
    baseUrl,
    storeId: window.LANDI_STORE_ID ?? DEFAULT_STORE_ID,
    storefrontId: window.LANDI_STOREFRONT_ID,
    authToken: window.LANDI_STORE_API_TOKEN,
  };
}

export function isApiModeEnabled(): boolean {
  return getStoreApiConfig() !== null;
}

export function getDefaultStoreId(): string {
  if (typeof window !== 'undefined' && window.LANDI_STORE_ID) {
    return window.LANDI_STORE_ID;
  }
  return DEFAULT_STORE_ID;
}
